import { useState, useEffect, useCallback } from "react";
import { assets } from '../../assets/assets.js';
import { toEthiopianDate, getAmharicMonth } from '../../utils/dateConverter';

// Move days array outside component to prevent re-creation on every render
const DAYS = ["አሚሩ", "ሰኑዩ", "ሠሉሱ", "ረቡዑ", "ኀሙሱ", "ሰዱሱ", "ሰብዑ"];

export default function BahireHasab() {
  const [gregorianDate, setGregorianDate] = useState("");
  const [ethiopianDate, setEthiopianDate] = useState(null);
  const [results, setResults] = useState(null);
  const [showYearCalendar, setShowYearCalendar] = useState(false);

  const getDays = useCallback((z) => {
    if (z < 0 || z > 7) return "Invalid";
    return DAYS[z - 1];
  }, []);

  // Full Bahire Hasab Calculation
  const calculateBahireHasab = useCallback((year, month, day) => {
    // Helper functions
    const calculateWenber = (y) => {
      let c = (y + 5500) % 532;
      if (c === 0) return 18;
      c %= 19;
      return c === 0 ? 18 : c - 1;
    };

    const getWeek = (z) => {
      const days = {
        1: { name: "ማግሰኞ", tewsak: 5 },
        2: { name: "ረቡዕ", tewsak: 4 },
        3: { name: "ኀሙስ", tewsak: 3 },
        4: { name: "ዓርብ", tewsak: 2 },
        5: { name: "ቀዳሚት ሰንበት", tewsak: 8 },
        6: { name: "ሰንበተ ክርስትያን ቅድስት", tewsak: 7 },
        0: { name: "ሰኞ", tewsak: 6 }
      };
      return days[z] || { name: "የተሳሳተ", tewsak: 0 };
    };

    const getWeekday = (date, month, sep1) => {
      const z = (date - 1 + 2 * (month - 1) + sep1) % 7;
      return getWeek(z).name;
    };

    const getWeekTew = (date, month, sep1) => {
      let z = (date - 1 + 2 * (month - 1) + sep1) % 7;
      if (z === 0) {
        z = 7;
      }
      return z;
    };

    const getWeekT = (date, month, sep1) => {
      const z = (date - 1 + 2 * (month - 1) + sep1) % 7;
      return getWeek(z).tewsak;
    };

    const getLeapYearName = (leapYear) => {
      return ["ዮሐንስ", "ማቴዎስ", "ማርቆስ", "ሉቃስ"][leapYear] || "የተሳሳተ";
    };

    const isLeapYear = (y) => (y + 5500) % 4 === 3;

    const addEthiopianDays = (year, month, day, daysToAdd) => { 
      // 2018,6,25,0  | 2019,5,15,0
      /*It has issue on 2019 so fix it */
      let totalDays = (month - 1) * 30 + day; //

      // Handle Pagume
      if (month > 12) {
        totalDays += isLeapYear(year) ? 6 : 5;
      }

      totalDays += daysToAdd;

      // Adjust year if needed
      const daysInYear = isLeapYear(year) ? 366 : 365;
      if (totalDays > daysInYear) {
        year++;
        totalDays -= daysInYear;
      }

      // Calculate new date
      let newMonth = Math.floor((totalDays - 1) / 30) + 1;
      let newDay = (totalDays - 1) % 30 + 1;

      // Handle Pagume in new year
      if (newMonth > 12) {
        newMonth = 13;
        newDay = totalDays - 360;
      }

      return `${newDay}/${newMonth}/${year}`;
    };

    // Main calculation
    const wenber1 = calculateWenber(year);
    const Abeqtie = (11 * wenber1) % 30;
    const Metqie = Abeqtie === 0 ? 30 : (19 * wenber1) % 30;
    const MeteneRabit = Math.floor((year + 5500) / 4);
    const leapYear = (year + 5500) % 4;
    const nextLeapYear = (year + 5501) % 4;
    const leapYearName = getLeapYearName(leapYear);
    const nextLeapYearName = getLeapYearName(nextLeapYear);
    const toSep = (MeteneRabit + year + 5500) % 7;
    const years = year + 5500;

    // Calculate BMT
    let BMT, bmt;
    let tewsakDay;

    if (Metqie >= 15) {
      BMT = (30 + Metqie) % 30;
      if (BMT === 0) BMT = 30;
      const Mtday = getWeekday(BMT, 1, toSep);
      tewsakDay = getWeekT(BMT, 1, toSep);
      bmt = `ቀኑ፡ መስከረም ${BMT} / ${year} - ${Mtday}`;
    } else {
      BMT = Metqie % 30;
      const Mtday = getWeekday(BMT, 2, toSep);
      tewsakDay = getWeekT(BMT, 2, toSep);
      bmt = `ቀኑ፡ ጥቅምት ${BMT} / ${year} - ${Mtday}`;
    }
    const MebajaHamer = (BMT + tewsakDay) % 30 || 30;

    // Calculate other values
    const Lelit = Abeqtie + Math.ceil(month / 2) + day;
    let Werih = (Lelit + 4) % 30;
    if (Werih === 0) { Werih = 30; }
    const Ilet = getWeekday(day, month, toSep);
    const KIlet = getWeekTew(day, month, toSep); //14, 1, 3
    const KIletDay = getDays(KIlet);
    const Osep = toSep - 1;
    const OIlet = getWeekTew(day, month, Osep); // 14,1,4
    const OIletDay = getDays(OIlet);
    const Esep = toSep + 2;
    const EIlet = getWeekTew(day, month, Esep); //14,1,1
    const EIletDay = getDays(EIlet);

    // 
    /*
     if(metqie on meskerem) { nenewie on tir}
         if(metqie on meskerem and mebaja hamer > 30) { nenewie on yekatit}
             if(metqie on Tikimt) { nenewie on yekatit}
             if(metqie on Tikimt and mebaja hamer > 30) { nenewie on yekatit}
    */
    // Calculate holidays
    const calculateHoliday = (daysToAdd) => {
      let month = 5;// if(MebajaHamer)
      if(Metqie < 14 || (Metqie > 14 && (BMT + tewsakDay) > 30 )){ month= 6; }
      // if()
      // ነነዌ ከጥር 17 እስከ የካቲት 21
      // console.log("Nenewe is on month ", month);
      return addEthiopianDays(year, month, MebajaHamer, daysToAdd);
    };

    return {
      wenber1,
      Abeqtie,
      Metqie,
      MebajaHamer,
      Lelit,
      years,
      Werih,
      EIlet,
      OIlet,
      KIlet,
      KIletDay,
      EIletDay,
      OIletDay,
      Mealt: day,
      Ilet,
      leapYearName,
      nextLeapYearName,
      MeteneRabit,
      sep1: `መስከረም 1: ${getWeekday(1, 1, toSep)}`,
      bmt,
      nn: `${calculateHoliday(0)}: ሰኞ`,
      ay: `${calculateHoliday(14)}: ሰኞ`,
      dz: `${calculateHoliday(41)}: እሑድ`,
      hn: `${calculateHoliday(62)}: እሑድ`,
      st: `${calculateHoliday(67)}: ዓርብ`,
      ta: `${calculateHoliday(69)}: እሑድ`,
      rc: `${calculateHoliday(93)}: ረቡዕ`,
      it: `${calculateHoliday(108)}: ሐሙስ`,
      ps: `${calculateHoliday(118)}: እሑድ`,
      hw: `${calculateHoliday(119)}: ሰኞ`,
      dt: `${calculateHoliday(121)}: ረቡዕ`,
      tir: `ጥምቀት (ጥር 11): ${getWeekday(11, 5, toSep)}`,
      sep17: `መስቀል (መስከረም 17)፡ ${getWeekday(17, 1, toSep)}`,
      meg: `በዓለ ትስብእት(መጋቢት 29)፡ ${getWeekday(29, 7, toSep)}`,
      tabor: `ደብረ ታቦር(ነሐሴ 13)፡ ${getWeekday(13, 12, toSep)}`,
      filseta: `ጾመ ፍልሰታ(ነሐሴ 1)፡ ${getWeekday(1, 13, toSep)}`,
      lidet: `ልደት (ታሕሳስ 29)፡ ${getWeekday(29, 4, toSep)}`,
      lideta: `ልደታ(ግንቦት 1)፡ ${getWeekday(1, 9, toSep)}`,
      hamle5: `ጴጥሮስ ወጳውሎስ ሐምሌ 5፡ ${getWeekday(1, 11, toSep)}`,
      hidar: ` ሕዳር ፆም(ሕዳር 15) ፡ ${getWeekday(15, 3, toSep)}`,
      Sep16: `ከተራ (መስከረም 16): ${getWeekday(16, 1, toSep)}`,
      Sep26: `ጽጌ (መስከረም 26): ${getWeekday(26, 1, toSep)}`,
      Nov6: `ቁስቋም (ሕዳር 6): ${getWeekday(6, 3, toSep)}`,
      Nov12: `ሚካኤል (ሕዳር 12): ${getWeekday(12, 3, toSep)}`,
      Dec3: `በዐታ (ታሕሳስ 3): ${getWeekday(3, 4, toSep)}`,
      Dec29: ` ልደት (ታሕሳስ 29): ${getWeekday(29, 4, toSep)}`,
      Jan21: `አስተርእዮ (ጥር 21): ${getWeekday(21, 5, toSep)}`,
      Feb16: ` ኪዳነምሕረት(የካቲት 16)፡ ${getWeekday(16, 6, toSep)}`,
      Jun20: `ሕንጸተ ቤታ(ሰኔ 20)፡ ${getWeekday(20, 10, toSep)}`,
      Jun21: ` ቅዳሴ ቤታ(ሰኔ 21)፡ ${getWeekday(21, 10, toSep)}`,
      Jul5: `ጴጥሮስ ወጳውሎስ (ሐምሌ 5)፡ ${getWeekday(5, 11, toSep)}`,
      Aug16: `ዕርገታ(ነሐሴ 16)፡ ${getWeekday(16, 12, toSep)}`,
    };
  }, [getDays]);

  const handleConvert = useCallback(() => {
    if (!gregorianDate) return;

    const date = new Date(gregorianDate);
    const ethiopian = toEthiopianDate(date);
    setEthiopianDate({ 
      year: ethiopian.ecYear, 
      month: ethiopian.ecMonth, 
      day: ethiopian.ecDay 
    });

    const calc = calculateBahireHasab(ethiopian.ecYear, ethiopian.ecMonth, ethiopian.ecDay);
    setResults(calc);
  }, [gregorianDate, calculateBahireHasab]);

  // Auto-calculate on page load with current date
  useEffect(() => {
    const today = new Date();
    const todayStr = today.toISOString().split('T')[0];
    setGregorianDate(todayStr);
    
    const ethiopian = toEthiopianDate(today);
    setEthiopianDate({ 
      year: ethiopian.ecYear, 
      month: ethiopian.ecMonth, 
      day: ethiopian.ecDay 
    });

    const calc = calculateBahireHasab(ethiopian.ecYear, ethiopian.ecMonth, ethiopian.ecDay);
    setResults(calc);
  }, [calculateBahireHasab]);

  // Render result items
  const renderResultItem = (label, value) => (
    <div className="result-item">
      <span className="result-label">{label}</span>
      <span className="result-value">{value}</span>
    </div>
  );

  // Render full year calendar
  const renderYearCalendar = (year, results) => {
    const months = [
      { name: "መስከረም", days: 30 },
      { name: "ጥቅምት", days: 30 },
      { name: "ኅዳር", days: 30 },
      { name: "ታኅሣሥ", days: 30 },
      { name: "ጥር", days: 30 },
      { name: "የካቲት", days: 30 },
      { name: "መጋቢት", days: 30 },
      { name: "ሚያዝያ", days: 30 },
      { name: "ግንቦት", days: 30 },
      { name: "ሰኔ", days: 30 },
      { name: "ሐምሌ", days: 30 },
      { name: "ነሐሴ", days: 30 },
      { name: "ጳጉሜ", days: ((year + 5500) % 4 === 3) ? 6 : 5 }
    ];

    const dayNames = ["ሰኞ", "ማክሰኞ", "እሮብ", "ኀሙስ", "አርብ", "ቅዳሜ", "እሑድ"];
    const dayNamesShort = ["ሰ", "ማ", "እ", "ኀ", "አ", "ቅ", "እሑ"];
    
    // Calculate the day of week for Meskerem 1 from results.sep1
    const sep1Text = results.sep1.split(': ')[1]; // Extract day name
    const sep1DayIndex = dayNames.indexOf(sep1Text);

    // Parse special dates from results
    const parseDate = (dateStr) => {
      if (!dateStr) return null;
      const match = dateStr.match(/(\d+)\/(\d+)\/\d+/);
      if (match) {
        return { day: parseInt(match[1]), month: parseInt(match[2]) };
      }
      return null;
    };

    // Create special dates map with categories
    const specialDates = new Map();
    
    // Fixed dates
    const fixedDates = [
      { month: 1, day: 16, name: "ከተራ", type: "fixed" },
      { month: 1, day: 17, name: "መስቀል", type: "feast" },
      { month: 1, day: 26, name: "ጽጌ", type: "fixed" },
      { month: 3, day: 6, name: "ቁስቋም", type: "fixed" },
      { month: 3, day: 12, name: "ሚካኤል", type: "fixed" },
      { month: 3, day: 15, name: "ጾመ ሒዳር", type: "fast" },
      { month: 4, day: 3, name: "በዐታ", type: "fixed" },
      { month: 4, day: 29, name: "ልደት", type: "feast" },
      { month: 5, day: 11, name: "ጥምቀት", type: "feast" },
      { month: 5, day: 21, name: "አስተርእዮ", type: "fixed" },
      { month: 6, day: 16, name: "ኪዳነምሕረት", type: "fixed" },
      { month: 7, day: 29, name: "በዓለ ትስብእት", type: "fixed" },
      { month: 9, day: 1, name: "ልደታ", type: "feast" },
      { month: 10, day: 20, name: "ሕንጸተ ቤታ", type: "fixed" },
      { month: 10, day: 21, name: "ቅዳሴ ቤታ", type: "fixed" },
      { month: 11, day: 5, name: "ጴጥሮስ ወጳውሎስ", type: "feast" },
      { month: 12, day: 1, name: "ጾመ ፍልሰታ", type: "fast" },
      { month: 12, day: 13, name: "ደብረ ታቦር", type: "fixed" },
      { month: 12, day: 16, name: "ዕርገታ", type: "feast" }
    ];

    fixedDates.forEach(date => {
      const key = `${date.month}-${date.day}`;
      specialDates.set(key, date);
    });

    // Movable dates from calculations
    const movableDates = [
      { date: parseDate(results.bmt), name: "በዓለ መጥቅዕ", type: "feast" },
      { date: parseDate(results.nn), name: "ነነዌ", type: "fast" },
      { date: parseDate(results.ay), name: "አብይ ጾም", type: "fast" },
      { date: parseDate(results.dz), name: "ደብረ ዘይት", type: "feast" },
      { date: parseDate(results.hn), name: "ሆሣዕና", type: "feast" },
      { date: parseDate(results.st), name: "ስቅለት", type: "fast" },
      { date: parseDate(results.ta), name: "ትንሳኤ", type: "feast" },
      { date: parseDate(results.rc), name: "ርክበ ካህናት", type: "feast" },
      { date: parseDate(results.it), name: "ዕርገት", type: "feast" },
      { date: parseDate(results.ps), name: "ጰራቅሊጦስ", type: "feast" },
      { date: parseDate(results.hw), name: "ጾመ ሐዋርያት", type: "fast" },
      { date: parseDate(results.dt), name: "ጾመ ድኅነት", type: "fast" }
    ];

    movableDates.forEach(item => {
      if (item.date) {
        const key = `${item.date.month}-${item.date.day}`;
        specialDates.set(key, { ...item.date, name: item.name, type: item.type });
      }
    });
    
    return (
      <div className="year-calendar-grid">
        {months.map((month, monthIndex) => {
          // Calculate starting day of week for this month
          // For Ethiopian calendar: each month has 30 days, so we can calculate offset
          let startDayIndex;
          if (monthIndex === 0) {
            // First month (Meskerem) starts on the day calculated from Bahire Hasab
            startDayIndex = sep1DayIndex;
          } else {
            // Each subsequent month starts 2 days later in the week (30 % 7 = 2)
            startDayIndex = (sep1DayIndex + (monthIndex * 2)) % 7;
          }
          
          return (
            <div key={monthIndex} className="month-calendar">
              <h4 className="month-name">{month.name}</h4>
              <div className="calendar-weekdays">
                {dayNamesShort.map((day, i) => (
                  <div key={i} className="weekday-header" title={dayNames[i]}>{day}</div>
                ))}
              </div>
              <div className="calendar-days-grid">
                {/* Empty cells for days before month starts */}
                {Array.from({ length: startDayIndex }).map((_, i) => (
                  <div key={`empty-${i}`} className="calendar-day-empty"></div>
                ))}
                
                {/* Actual days of the month */}
                {Array.from({ length: month.days }).map((_, dayNum) => {
                  const day = dayNum + 1;
                  const dayOfWeek = (startDayIndex + dayNum) % 7;
                  const isToday = ethiopianDate.month === monthIndex + 1 && ethiopianDate.day === day;
                  const isSunday = dayOfWeek === 6;
                  
                  const dateKey = `${monthIndex + 1}-${day}`;
                  const specialDate = specialDates.get(dateKey);
                  
                  return (
                    <div 
                      key={day} 
                      className={`calendar-day-cell ${isToday ? 'today' : ''} ${isSunday ? 'sunday' : ''} ${specialDate ? 'special-date' : ''} ${specialDate ? specialDate.type : ''}`}
                      title={specialDate ? `${dayNames[dayOfWeek]} - ${specialDate.name}` : dayNames[dayOfWeek]}
                    >
                      <span className="day-number">{day}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="page-container bahire-theme">
      <div className="page-header">
        <h1 className="page-main-title">
          📅 ባሕረ ሐሳብ
        </h1>
        <div className="page-subtitle">
          ግሪጎርያን → ኢትዮጵያ + ባሕረ ሐሳብ
        </div>
        <div className="page-description">
          <p className="page-description-main">
            የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ ክርስቲያን የቀን መቁጠሪያ መለወጫ
          </p>
          <p className="page-description-sub">
            Ethiopian Orthodox Tewahedo Church calendar converter and calculations
          </p>
        </div>
      </div>

      <div className="controls-container">
        <div className="controls-grid">
          <div className="control-group">
            <label className="control-label">የግሪጎሪያን ቀን:</label>
            <input
              type="date"
              value={gregorianDate}
              onChange={(e) => setGregorianDate(e.target.value)}
              className="control-input"
            />
          </div>
          <div className="control-group">
            <button onClick={handleConvert} className="control-button">
              <span className="text-lg">📅</span> አስላ
            </button>
          </div>
        </div>
        
        {/* Year Calendar Toggle */}
        {ethiopianDate && (
          <div className="mt-4">
            <button 
              onClick={() => setShowYearCalendar(!showYearCalendar)} 
              className="btn-success"
            >
              {showYearCalendar ? '📅 ቀን መቁጠሪያን ደብቅ' : '📅 የ' + ethiopianDate.year + ' ዓ.ም ሙሉ ቀን መቁጠሪያን አሳይ'}
            </button>
          </div>
        )}
      </div>

      {/* Full Year Ethiopian Calendar */}
      {showYearCalendar && ethiopianDate && results && (
        <div className="content-container mb-6">
          <div className="content-header">
            <div className="content-icon">📅</div>
            <h3 className="content-title">የ{ethiopianDate.year} ዓ.ም የኢትዮጵያ ቀን መቁጠሪያ</h3>
          </div>
          <p className="text-sm text-gray-600 mb-4">መስከረም 1 = {results.sep1}</p>
          
          {/* Legend */}
          <div className="calendar-legend-box flex flex-wrap gap-2 mb-4 text-xs">
            <div className="legend-item flex items-center gap-1">
              <span className="inline-block w-3 h-3 rounded bg-green-200 border border-green-500"></span>
              <span>በዓላት</span>
            </div>
            <div className="legend-item flex items-center gap-1">
              <span className="inline-block w-3 h-3 rounded bg-amber-200 border border-amber-500"></span>
              <span>ጾሞች</span>
            </div>
            <div className="legend-item flex items-center gap-1">
              <span className="inline-block w-3 h-3 rounded bg-blue-200 border border-blue-400"></span>
              <span>ሌሎች ቀናት</span>
            </div>
            <div className="legend-item flex items-center gap-1">
              <span className="legend-box today-box inline-block w-3 h-3 bg-blue-600 border border-blue-700"></span>
              <span>ዛሬ</span>
            </div>
            <div className="legend-item flex items-center gap-1">
              <span className="legend-box sunday-box inline-block w-3 h-3 bg-red-100 border border-red-400"></span>
              <span>እሑድ</span>
            </div>
          </div>

          {renderYearCalendar(ethiopianDate.year, results)}
        </div>
      )}

      {ethiopianDate && (
        <div className="content-container mb-6">
          <div className="content-header">
            <div className="content-icon">🗓️</div>
            <h3 className="content-title">የኢትዮጵያ ቀን:</h3>
          </div>
          <p className="text-2xl font-bold text-green-600">{ethiopianDate.day}/{ethiopianDate.month}/{ethiopianDate.year}</p>
        </div>
      )}

      {results && (
        // <div className="results-container">
        //   <div className="results-header">
        //     <h3>የባሕረ ሐሳብ ውጤቶች</h3>
        //     <div className="decoration">✝ አሥርቆት</div>
        //   </div>

        <div className="results-container">
          <div className="results-header">
            <h3>የባሕረ ሐሳብ ውጤቶች</h3>
            <div className="decoration">
              <a href="#asrqot-part" style={{ textDecoration: "none", color: "inherit" }}>
                ✝ አሥርቆት
              </a>
            </div>
          </div>

          <div className="results-grid">
            <div className="result-category">
              <h4>መሰረታዊ ስሌቶች</h4>
              {renderResultItem('ወንበር:', results.wenber1)}
              {renderResultItem('አበቅቴ:', results.Abeqtie)}
              {renderResultItem('መጥቅዕ:', results.Metqie)}
              {renderResultItem('መባጃ ሐመር:', results.MebajaHamer)}
            </div>

            <div className="result-category">
              <h4>የሰዓት ስሌቶች</h4>
              {renderResultItem('ሠርቀ ለሊት:', results.Lelit)}
              {renderResultItem('ሠርቀ ወርኅ:', results.Werih)}
              {renderResultItem('ሠርቀ መዐልት:', results.Mealt)}
              {renderResultItem('ሠርቀ ዕለት:', results.Ilet)}
            </div>

            <div className="result-category">
              <h4>ዓመት እና ቀን</h4>
              {renderResultItem('ወንጌል:', results.leapYearName)}
              {renderResultItem('መስከረም 1:', results.sep1)}
              {renderResultItem('በዓለ መጥቅዕ:', results.bmt)}
            </div>

            <div className="result-category">
              <h4>ጾሞች እና በዓላት</h4>
              {renderResultItem('ነነዌ:', results.nn)}
              {renderResultItem('አብይ ጾም:', results.ay)}
              {renderResultItem('ጾመ ሐዋርያት:', results.hw)}
              {renderResultItem('ጾመ ድኅነት:', results.dt)}
              {renderResultItem('ጾመ ፍልሰታ:', results.filseta)}
              {renderResultItem('ጾመ ሒዳር:', results.hidar)}

            </div>

            <div className="result-category">
              <h4>ተጨማሪ በዓላት</h4>
              {renderResultItem('ደብረ ዘይት:', results.dz)}
              {renderResultItem('ሆሣዕና:', results.hn)}
              {renderResultItem('ስቅለት:', results.st)}
              {renderResultItem('ትንሳኤ:', results.ta)}
              {renderResultItem('ርክበ ካህናት:', results.rc)}
              {renderResultItem('ዕርገት:', results.it)}
              {renderResultItem('ጰራቅሊጦስ:', results.ps)}
            </div>

            <div className="result-category">
              <h4>ሌሎች ቀናት</h4>
              {renderResultItem('መስከረም 16:', results.Sep16)}
              {renderResultItem('መስከረም 17:', results.sep17)}
              {renderResultItem('ጽጌ መስከረም 26', results.Sep26)}
              {renderResultItem('ቁስቋም (ሕዳር 6)', results.Nov6)}
              {renderResultItem('ሚካኤል (ሕዳር 12)', results.Nov12)}
              {renderResultItem('በዐታ (ታሕሳስ 3)', results.Dec3)}
              {renderResultItem('ልደተ ኢየሱስ ክርስቶስ', results.lidet)}
              {renderResultItem('ልደት (ታሕሳስ 29)', results.Dec29)}
              {renderResultItem('ጥምቀት: ', results.tir)}
              {renderResultItem('አስተርእዮ (ጥር 21)', results.Jan21)}
              {renderResultItem('ኪዳነምሕረት(የካቲት 16)', results.Feb16)}
              {renderResultItem('በዓለ ትስብእት(መጋቢት 29)', results.meg)}
              {renderResultItem('ልደታ ለማርያም (ግንቦት 1):', results.lideta)}
              {renderResultItem('ሕንጸተ ቤታ(ሰኔ 20)', results.Jun20)}
              {renderResultItem('ቅዳሴ ቤታ(ሰኔ 21)', results.Jun21)}
              {renderResultItem('ጴጥሮስ ወጳውሎስ (ሐምሌ 5)', results.Jul5)}
              {renderResultItem('ደብረ ታቦር: ', results.tabor)}
              {renderResultItem('ዕርገታ(ነሐሴ 16)', results.Aug16)}

            </div>
            <div id="asrqot-part" className="result-category asirqot-section">
              <h4 className="asirqot-header">📖 አሥርቆት(ዘመኑን አስቦ ፈጣሪን ማመስገን)</h4>

              <div className="asirqot-subheader">
                በመጀመሪያ አአትብ ገጽየ እስከ ስብሐት መድገም(ስብሐትን አይጨምርም)
              </div>

              <div className="asirqot-subheader">
                በመቀጠል የሚከተለውን ማለት (ነአኵቶ ለገባሬ ሠናያትን እስከ ተፍጻሜቱ ብለ)
              </div>

              <div className="asirqot-images">
                <div className="asirqot-image-container">
                  <img src={assets.asrqot} alt="ነአኩቶ ለገባረ ሠናያት ላዕሌነ እግዚአብሔር መሐሪ" className="asirqot-image" />
                  <div className="asirqot-image-caption">ነአኩቶ ለገባረ ሠናያት</div>
                </div>
                <div className="asirqot-image-container">
                  <img src={assets.asrqot1} alt="ኅሡ ወአስተበቁዑ ከመ ይምሐረነ እግዚአብሔር ወይሣሃል ላዕሌነ" className="asirqot-image" />
                  <div className="asirqot-image-caption">ኅሡ ወአስተበቁዑ</div>
                </div>
              </div>
              <div className="asirqot-content">
                {/* Content with appropriate class names for different sections */}
                <span className="asirqot-decoration">➲</span> በስመ አብ ወወልድ ወመንፈስ ቅደስ ፩ዱ አምላክ ሃሌ ሉያ በዘንዜከር ሐሳባተ ሕጉ ወትእዛዛቲሁ ለእግዘእነ ወአምላክነ ወመድኃኒነ ኢየሱስ ክርስቶስ እንዘ ሀሎነ በዘመነ ቅዱስ <strong>{results.leapYearName}</strong> ወንጌላዊ ቡሩክ ያብጽሐነ እስከ ዘመነ <strong>{results.nextLeapYearName}</strong> ዜናዊ።

                <div className="asirqot-highlight">
                  <span className="asirqot-decoration">➯</span> በ<strong>{results.years}</strong> ኮነ ዓመተ ዓለም።<br />
                  <span className="asirqot-decoration">➯</span> በ፶፻፭፻(5500) ኮነ ዓመተ ኵነኔ ዓመተ ፍዳ።<br />
                  <span className="asirqot-decoration">➯</span> በ<strong>{ethiopianDate.year}</strong> ኮነ ዓመተ ምሕረት<br />
                  <span className="asirqot-decoration">➯</span> ዮም ሠረቀ ለነ ወርኀ <strong>{getAmharicMonth(ethiopianDate.month)}</strong> ቡሩክ ያብጽሐነ እስከ ወርኃ <strong>{getAmharicMonth(ethiopianDate.month % 13 + 1)}</strong> በሰላመ እግዘአብሔር አብ አሜን።
                </div>

                {/* Continue styling the rest of the content with appropriate class names */}

                <div className="asirqot-prayer">
                  {/* Prayer content */}
                  <strong >{results.Mealt}</strong> ሠርቀ መዓልት፣
                  <br />
                  <strong >{results.Lelit}</strong> ሠርቀ ሌሊት፣
                  <br />
                  <strong >{results.Werih}</strong> ሠርቀ ወርኅ፣
                  <br />
                  <strong >{results.OIlet} ||| {results.OIletDay}</strong> ጥንተ ዖን፣
                  <br />
                  <strong >{results.EIlet} ||| {results.EIletDay}</strong> ጥንተ ዕለት፣
                  <br />
                  <strong >{results.KIlet} ||| {results.KIletDay}</strong> ጥንተ ቀመር
                  <br />ዮም ኮነ በዛቲ ዕለት ዘተበስረ በአፈ ካህን ኅሩይ ወለባዊ
                  <br /> <span >➤</span> ዝ ዕጣን ወዝ ጸሎት ወዝ አስተብቍዖት ወዝ መሥዋዕት ይዕርግ በእንተ ስመ እግዘአብሓር አብ ወበእንተ ተዛካረ ወልደ እግዚእነ ኢየሱስ ክርስቶስ ወበእንተ ስሙ ለመንፈስ ቅደስ ጰራቅሊጦስ ወበእንተ ስማ ለእግዝእትነ ማርያም ወላዲተ አምላክ።
                  <br />
                  <span >➲</span> ጸልዩ በእንተ ዕጣን ከመ ይኵን ኅሩየ ወሥሙረ።
                </div>

                <div className="asirqot-instruction">
                  ❤ ከዘመን መለወጫ ቀን ውጭ ለሆነው ጸሎት ሁሉ ኅሩየ ወሥሙረ ካለ በኋላ ስብሐት ይበል።
                </div>

                {/* Continue with the rest of the content */}
                <div className="asrqot-prayer">
                  <span >➤</span> የዘመን መለወጫ ዕለት የሆነ እንደሆነ አዋጅ ስትነግር ስብሐት የለውም።
                  <br />
                  <span >➲</span> ጸልዩ በእንተ ዕጣን ከመ ይኵን ኅሩየ ወሥሙረ ካልክ በኋላ ጸልተ ዕጣንን ከቅዳሴው በል። ፀጋ ዘአብ ኂሩት ወለወልድ ሱታፌ ለመንፈስ ቅደስ ወበረከታ ለእግዝእትነ ማርያም ወላዲተ አምላክ ተፋቅሮ ዘነቢያት ወለሐዋርያት ለጻድቃን ወሰማዕት ወዘአበው ቀደምት ቅደሳን ወለትጉሃን መላእክት ወትረ የሃሉ ምስሌየ ወምስለ ኵሌክሙ።
                  <br />
                  <span >➤</span> ይ.ሔ አሜን። ፫ ጊዚ በሌ።
                  <br />
                  <span >➲</span> እግዘአብሔር የሃቦ ለብፁዕ ወለቅደስ ርእሰ ሉቃነ ጳጳሳት አባ ማትያስ ወብጹዕ ሉቀ ጳጳስነ አባ ዮሐንስ ወኵልሙ ሉቃነ ጳጳሳት ወኤጲስቆጶሳት ቀሳውስት ወዲያቆናት ርቱዓነ ሃይማኖት ጸሎተ&#0; ዘጸለዩ ወዕጣነ ዘወገሩ ውስተ ኑኃ ሰማይ ዘየዐርግ ወመዓተ እግዘአብሔር ዘያቈርር ወኃጢአተ ዓለም ዘያስተሰሪ ለይኵን።
                  <br />
                  <span >➲</span> ይ.ሔ አሜን። እግዘአብሔር የሃቦ ለመፍቀሬ እግዘአብሔር ንጉሥነ ኀበ ኀለየ በልቡ ወኀበ አንጸረ በአጽባዒቱ ፀሩ ወጸሊዒቱ ያርኅቅ ወያቅርብ በኃይለ መስቀሉ ለእግዘእነ ኢየሱስ ክርስቶስ ግሩራነ ለይኵኑ ታሕተ እገሪሁ ፍጡነ።
                  <br />
                  <span >➲</span>ይ.ሔ አሜን። እግዘአብሓር የሀብክሙ ለክሙኒ ለሕዝበ ክርስቲያን ፈሪሀ ስሙ ወስነ አምልኮቱ ወጸጋ ረዴኤቱ።
                  <br />
                  <span >➲</span> ይ.ሔ አሜን። እግዘአብሓር ያቍርር መዓቶ ወይፈኑ ሣህሎ ወምሕረቶ ወምድር (፫ ጊዚ በል)። ይ.ሔ አሜን (፫ ጊዜ)።
                  <br />
                  <span >➲</span> ይ.ካ እነግረክሙ አኃውየ ከመ ታእምሩ ጸጋሁ ለመንፈስ ቅደስ ወትረ የሃሉ ምስሌየ ወምስለ ኵሌክሙ አሜን። ስብሐት ወክብር ለሥለስ ቅደስ አብ ወወልድ ወመንፈስ ቅዱስ ይእዜኒ ወዘልፈኒ ወለዓለመ ዓለም አሜን።
                  <br />
                  <span >➲</span> ከዘህ ቀጥሎ ከመዛሙረ ዲዊት ፺፱ኙን መዝሙር የብቡን በል።
                  <br /><br />
                  <span >➲</span> ከዘህ በመቀጠል።
                  <br />
                  <span >➽</span> ዘመነ ዮሐንስ አለፈ ዘመነ ማቴዎስ ተተካ። news
                  <br />
                  <span >♻️</span> ዮሐንስ ተሻረ ማቴዎስ ተተካ (፫ ጊዚ በሌ)።
                  <br />
                  <span >➲</span> ሕዝቡም በእልልታ ይቀበለሉ። በጭብጨባ ከዘመነ ዮሐንስ ወደ ዘመነ ማቴዎስ በሰላም እንዳደረሰን እንዲሁም ከዘመነ ማቴዎስ ወደ ዘመነ ማርቆስ በሰላም ያሻግረን አሜን።
                  <br />
                  <span >➤</span> አነሳስቶ ሊስጀመረን አስጀምሮ ላስፈጸመን ለልዑል እግዘአብሔር ክብርና ምስጋና ይግባው አሜን ወአሜን ለይኩን ለይኩን።
                  <br /><br />
                  <span >➤</span> በመጨረሻም የቀረበውን ዔጣን፣ ሥርናይ፣ ዘቢብ ይባርክና ስንብት&#0; ይሆናል።
                </div>

                <div className="asirqot-final-note">
                  ➨ የተባረከው ዕጣን ሥርናይ ዘቢብ ከንጹሕ ስፍራ ተቀምጦ ትንሽ ትንሽ እየተጨመረ ለዓመት መቀደሻ ይሆናል፡፡
                </div>
              </div>

              <h4 className="asirqot-amen">ስብሐት ለአብ...</h4>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}